import * as doT from 'dot';

declare global {
	interface Window {
		doT : typeof doT;
	}
}

window.doT = doT;

export { RenderFunction } from 'dot';

export default doT;



// WEBPACK FOOTER //
// typescript://../clientlibs/js/bootstrap/load-dot.ts